var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import unlockAcademics from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_academics.png';
import unlockAcademicsFull from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_academics_full.png';
import unlockAchievement from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_achievement.png';
import unlockAchievementFull from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_achievement_full.png';
import unlockCommunities from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_communities.png';
import unlockCommunitiesFull from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_communities_full.png';
import unlockSkills from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_skills.png';
import unlockSkillsFull from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_skills_full.png';
import { ActionTabs } from '@backrs_ui/common-ui/src/atoms/ActionTabs';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { StandardsByTrackModal } from '@backrs_ui/common-ui/src/molecules/AssessMyTrack/StandardsByTrackModal';
import { BASE_NUGGET_HEIGHT, BASE_NUGGET_WIDTH, } from '@backrs_ui/common-ui/src/molecules/Nugget/BaseNugget';
import { TypeChip } from '@backrs_ui/common-ui/src/molecules/Nugget/TypeChip';
import { Box, Typography, Button } from '@mui/material';
import ReactMarkdown from 'react-markdown';
var UNLOCK_STRINGS = appStrings.modules.nugget.unlockCard;
var ACTION_TAB_STRINGS = appStrings.modules.actionTabs;
var CATEGORY_IMAGES = {
    'academic-foundations': unlockAcademics,
    'real-world-experience': unlockAchievement,
    'mindsets-and-skills': unlockSkills,
    'community-of-success': unlockCommunities,
    none: '',
};
var CATEGORY_IMAGES_FULL = {
    'academic-foundations': unlockAcademicsFull,
    'real-world-experience': unlockAchievementFull,
    'mindsets-and-skills': unlockSkillsFull,
    'community-of-success': unlockCommunitiesFull,
    none: '',
};
var getCardContainerSx = function (variant) {
    return cardContainerStyles[variant];
};
var ReactMarkdownWithTypography = function (_a) {
    var children = _a.children;
    return (_jsx(ReactMarkdown, { components: {
            p: function (_a) {
                var children = _a.children;
                return (_jsx(Typography, { variant: "text-sm-regular", sx: { color: function (_a) {
                            var backrs = _a.backrs;
                            return backrs.colors['Colors/Text/text-tertiary'];
                        } }, children: children }));
            },
            li: function (_a) {
                var children = _a.children;
                return (_jsx("li", { children: _jsx(Typography, { variant: "text-sm-regular", sx: { color: function (_a) {
                                var backrs = _a.backrs;
                                return backrs.colors['Colors/Text/text-tertiary'];
                            } }, children: children }) }));
            },
            ul: function (_a) {
                var children = _a.children;
                return _jsx("ul", { style: ulStyle, children: children });
            },
        }, children: children }));
};
var BlockedAssessmentContent = function (_a) {
    var text = _a.text, onBlockAssessmentButtonClick = _a.onBlockAssessmentButtonClick, categorySlug = _a.categorySlug;
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: customDividerSx, children: [_jsx(Box, { sx: leftLineSx }), _jsx(Typography, { sx: dividerTextSx, children: UNLOCK_STRINGS.strengthsAndOpportunities }), _jsx(Box, { sx: rightLineSx })] }), _jsxs(Box, { sx: blockedContentItemSx, children: [_jsx(Box, { sx: blockedIconContainerSx, children: _jsx(AppIcon, { iconName: "Target03", diameter: "32px", color: "Colors/Foreground/fg-brand-primary" }) }), _jsx(ReactMarkdownWithTypography, { children: text })] }), _jsx(Button, { hierarchy: "Secondary gray", size: "md", sx: uploadTranscriptButtonSx, onClick: onBlockAssessmentButtonClick, id: categorySlug ? "assess-track-upload-transcript-".concat(categorySlug) : undefined, children: UNLOCK_STRINGS.uploadYourTranscript })] }));
};
var LargeVariantContent = function (_a) {
    var variant = _a.variant;
    return (_jsxs(_Fragment, { children: [variant.strengths.length > 0 && (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: customDividerSx, children: [_jsx(Box, { sx: leftLineSx }), _jsx(Typography, { sx: dividerTextSx, children: UNLOCK_STRINGS.strengths }), _jsx(Box, { sx: rightLineSx })] }), variant.strengths.map(function (item, index) { return (_jsxs(Box, { children: [_jsxs(Box, { sx: contentItemSx, children: [_jsx(Box, { sx: iconContainerSx, children: _jsx(AppIcon, { iconName: "CheckCircle", diameter: "32px", color: "Green/500" }) }), _jsx(ReactMarkdownWithTypography, { children: item })] }), (index < variant.strengths.length - 1 || variant.opportunities.length === 0) && (_jsx(Box, { sx: dividerSx }))] }, "strength-".concat(index))); })] })), variant.opportunities.length > 0 && (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: customDividerSx, children: [_jsx(Box, { sx: leftLineSx }), _jsx(Typography, { sx: dividerTextSx, children: UNLOCK_STRINGS.opportunitiesToGrow }), _jsx(Box, { sx: rightLineSx })] }), variant.opportunities.map(function (item, index) { return (_jsxs(Box, { children: [_jsxs(Box, { sx: contentItemSx, children: [_jsx(Box, { sx: iconContainerSx, children: _jsx(AppIcon, { iconName: "Target03", diameter: "32px", color: "Colors/Foreground/fg-brand-primary" }) }), _jsx(ReactMarkdownWithTypography, { children: item })] }), _jsx(Box, { sx: dividerSx })] }, "opportunity-".concat(index))); })] }))] }));
};
var TinyUnlockCard = function (_a) {
    var variant = _a.variant;
    return (_jsxs(Box, { sx: getCardContainerSx('TINY'), children: [_jsx(Box, { sx: tinyVariantHeaderSx, children: _jsx(Box, { component: "img", src: CATEGORY_IMAGES_FULL[variant.category.slug], alt: "Unlock ".concat(variant.category.name), sx: tinyVariantUnlockImageSx }) }), _jsx(Box, { sx: tinyVariantCardBodySx, children: _jsx(Box, { sx: tinyContentContainerSx, children: _jsxs(Typography, { variant: "text-sm-medium", sx: descriptionTextSx, children: [_jsx("strong", { children: variant.category.name }), ": ", variant.category.description] }) }) })] }));
};
var SmallUnlockCard = function (_a) {
    var variant = _a.variant;
    return (_jsxs(Box, { sx: getCardContainerSx('SMALL'), onClick: variant.onClick, children: [_jsx(Box, { sx: headerSx, children: _jsx(Box, { component: "img", src: CATEGORY_IMAGES[variant.category.slug], alt: "Unlock ".concat(variant.category.name), sx: unlockImageSx }) }), !variant.hideContent && (_jsxs(Box, { sx: cardBodySx, children: [_jsx(Box, { sx: titleRowSx, children: _jsxs(Box, { sx: titleAndDescriptionSx, children: [_jsxs(Typography, { variant: "text-xl-semibold", sx: titleSmallVariantSx, children: [variant.category.name, ' ', _jsx(Box, { component: "span", sx: infoIconContainerSx, children: _jsx(AppIcon, { iconName: "InfoCircle", diameter: "20px", color: "Colors/Base/Black" }) })] }), _jsx(Typography, { variant: "text-xs-medium", sx: descriptionTextSx, children: variant.category.description })] }) }), _jsxs(Box, { sx: smallContentContainerSx, children: [_jsx(Box, { sx: smallContentItemsSx, children: __spreadArray(__spreadArray([], variant.strengths, true), variant.opportunities, true).slice(0, 2).map(function (item, index) { return (_jsxs(Box, { children: [_jsx(Box, { sx: dividerSx }), _jsx(Box, { sx: smallContentTextSx, children: _jsx(ReactMarkdownWithTypography, { children: item }) })] }, index)); }) }), _jsx(TypeChip, { label: UNLOCK_STRINGS.fourUnlocks, icon: "LockKeyholeSquare" })] })] }))] }));
};
var LargeUnlockCard = function (_a) {
    var variant = _a.variant;
    var _b = useState(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = useState(false), showCopySuccess = _c[0], setShowCopySuccess = _c[1];
    return (_jsxs(Box, { sx: getCardContainerSx('LARGE'), children: [_jsx(Box, { sx: headerSx, children: _jsx(Box, { component: "img", src: CATEGORY_IMAGES[variant.category.slug], alt: "Unlock ".concat(variant.category.name), sx: unlockImageSx }) }), !variant.hideContent && (_jsxs(Box, { sx: cardBodySx, children: [_jsxs(Box, { sx: titleRowSx, children: [_jsxs(Box, { sx: titleAndDescriptionSx, children: [_jsxs(Typography, { variant: "text-xl-semibold", sx: titleLargeVariantSx, children: [variant.category.name, ' ', _jsx(Box, { component: "span", sx: infoIconContainerSx, onClick: function () { return setIsModalOpen(true); }, id: "assess-track-unlock-info-".concat(variant.category.slug), children: _jsx(AppIcon, { iconName: "InfoCircle", diameter: "20px", color: "Colors/Base/Black" }) })] }), _jsx(Typography, { variant: "text-xs-medium", sx: descriptionTextSx, children: variant.category.description })] }), _jsx(Box, { sx: actionTabsContainerSx, children: _jsx(ActionTabs, { actions: [
                                        {
                                            icon: variant.hasBookmarked ? 'BookmarkCheck' : 'Bookmark',
                                            onClick: variant.onBookmark,
                                            id: "assess-track-unlock-bookmark-".concat(variant.category.slug),
                                            tooltipHoverText: ACTION_TAB_STRINGS.bookmark,
                                        },
                                        {
                                            icon: 'Share06',
                                            onClick: variant.onShare,
                                            id: "assess-track-unlock-share-".concat(variant.category.slug),
                                            tooltipHoverText: ACTION_TAB_STRINGS.share,
                                        },
                                        {
                                            icon: 'BookmarkAdd',
                                            onClick: variant.onAddTask,
                                            id: "assess-track-unlock-add-task-".concat(variant.category.slug),
                                            tooltipHoverText: ACTION_TAB_STRINGS.task,
                                        },
                                    ], showCopySuccess: showCopySuccess, onCopySuccessChange: setShowCopySuccess, borderColor: "Colors/Border/border-primary", disabled: variant.disableButtons || !!variant.blockAssessmentText }) })] }), variant.blockAssessmentText ? (_jsx(BlockedAssessmentContent, { text: variant.blockAssessmentText, onBlockAssessmentButtonClick: variant.onBlockAssessmentButtonClick, categorySlug: variant.category.slug })) : (_jsx(LargeVariantContent, { variant: variant }))] })), variant.standardsVariant && (_jsx(StandardsByTrackModal, { open: isModalOpen, onClose: function () { return setIsModalOpen(false); }, category: variant.category, variant: variant.standardsVariant }))] }));
};
export var UnlockCard = function (_a) {
    var id = _a.id, variant = _a.variant;
    var inner = (function () {
        switch (variant.type) {
            case 'TINY':
                return _jsx(TinyUnlockCard, { variant: variant });
            case 'SMALL':
                return _jsx(SmallUnlockCard, { variant: variant });
            case 'LARGE':
                return _jsx(LargeUnlockCard, { variant: variant });
            default:
                return (_jsx(TinyUnlockCard, { variant: variant }));
        }
    })();
    if (id) {
        return _jsx(Box, { id: id, children: inner });
    }
    return inner;
};
var tinyCardContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        borderRadius: backrs.radius['radius-xl'],
        border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        overflow: 'hidden',
        height: '100%',
        backgroundColor: backrs.colors['Colors/Base/White'],
        minWidth: '307px',
        minHeight: '219px',
    });
};
var smallCardContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        borderRadius: backrs.radius['radius-4xl'],
        border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        overflow: 'hidden',
        height: '100%',
        backgroundColor: backrs.colors['Gray/700'],
        maxWidth: BASE_NUGGET_WIDTH,
        maxHeight: BASE_NUGGET_HEIGHT,
        cursor: 'pointer',
        minHeight: BASE_NUGGET_HEIGHT,
    });
};
var largeCardContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        borderRadius: backrs.radius['radius-xl'],
        border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        overflow: 'hidden',
        height: '100%',
        backgroundColor: backrs.colors['Gray/700'],
    });
};
var cardContainerStyles = {
    TINY: tinyCardContainerSx,
    SMALL: smallCardContainerSx,
    LARGE: largeCardContainerSx,
};
var headerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        height: '72px',
        backgroundColor: backrs.colors['Gray/700'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        position: 'relative',
    });
};
var unlockImageSx = {
    height: '100%',
    width: 'auto',
    objectFit: 'contain',
    maxWidth: '100%',
};
var cardBodySx = function (_a) {
    var backrs = _a.backrs;
    return ({
        padding: backrs.spacing['spacing-2xl'],
        backgroundColor: backrs.colors['Colors/Base/White'],
        borderRadius: "".concat(backrs.radius['radius-xl'], " ").concat(backrs.radius['radius-xl'], " 0px 0px"),
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    });
};
var titleRowSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: {
            xs: 'column',
            sm: 'row',
        },
        columnGap: backrs.spacing['spacing-lg'],
        justifyContent: 'space-between',
        alignItems: {
            xs: 'flex-end',
            sm: 'flex-start',
        },
        marginBottom: backrs.spacing['spacing-sm'],
    });
};
var blockedContentItemSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: backrs.spacing['spacing-sm'],
        paddingTop: backrs.spacing['spacing-4xl'],
        paddingBottom: backrs.spacing['spacing-4xl'],
    });
};
var contentItemSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: backrs.spacing['spacing-sm'],
        paddingTop: backrs.spacing['spacing-md'],
        paddingBottom: backrs.spacing['spacing-md'],
    });
};
var blockedIconContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        flexShrink: 0,
        marginRight: backrs.spacing['spacing-4xl'],
        marginLeft: backrs.spacing['spacing-2xl'],
    });
};
var iconContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        flexShrink: 0,
        marginRight: backrs.spacing['spacing-lg'],
    });
};
var dividerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        height: '1px',
        backgroundColor: backrs.colors['Gray/300'],
        marginTop: backrs.spacing['spacing-sm'],
        marginBottom: backrs.spacing['spacing-sm'],
        marginLeft: "-".concat(backrs.spacing['spacing-2xl']),
        marginRight: "-".concat(backrs.spacing['spacing-2xl']),
    });
};
var customDividerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'center',
        marginTop: backrs.spacing['spacing-md'],
        marginLeft: "-".concat(backrs.spacing['spacing-2xl']),
        marginRight: "-".concat(backrs.spacing['spacing-2xl']),
    });
};
var leftLineSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        height: '1px',
        width: '48px',
        backgroundColor: backrs.colors['Gray/300'],
    });
};
var rightLineSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        height: '1px',
        flex: 1,
        backgroundColor: backrs.colors['Gray/300'],
    });
};
var dividerTextSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Colors/Text/text-secondary'],
        fontSize: '14px',
        fontWeight: 600,
        backgroundColor: backrs.colors['Colors/Base/White'],
        paddingLeft: backrs.spacing['spacing-xl'],
        paddingRight: backrs.spacing['spacing-xl'],
        marginLeft: backrs.spacing['spacing-sm'],
        marginRight: backrs.spacing['spacing-sm'],
    });
};
var titleAndDescriptionSx = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
};
var infoIconContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'inline-flex',
        verticalAlign: 'middle',
        cursor: 'pointer',
        mb: backrs.spacing['spacing-xs'],
        ml: backrs.spacing['spacing-xs'],
    });
};
var tinyContentContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        padding: backrs.spacing['spacing-sm'],
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlign: 'left',
    });
};
var tinyVariantHeaderSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        height: '110px',
        backgroundColor: '#E8F0FF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        borderBottom: "1px solid ".concat(backrs.colors['Gray/900']),
        overflow: 'hidden',
    });
};
var tinyVariantUnlockImageSx = {
    height: '115%',
    width: 'auto',
    objectFit: 'contain',
    maxWidth: '105%',
    transform: 'scale(1.15)',
};
var tinyVariantCardBodySx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        padding: backrs.spacing['spacing-lg'],
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    });
};
var smallContentContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-sm'],
        marginTop: backrs.spacing['spacing-md'],
        flex: 1,
    });
};
var smallContentItemsSx = {
    flex: 1,
};
var descriptionTextSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Colors/Text/text-tertiary'],
    });
};
var smallContentTextSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        lineHeight: '1.4',
        color: backrs.colors['Colors/Text/text-tertiary'],
        marginBottom: backrs.spacing['spacing-md'],
        marginTop: backrs.spacing['spacing-md'],
    });
};
var titleSmallVariantSx = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    width: '100%',
};
var titleLargeVariantSx = {
    display: 'inline',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
};
var actionTabsContainerSx = {
    order: {
        xs: -1,
        sm: 0,
    },
};
var ulStyle = {
    marginTop: '0',
    marginLeft: '1em',
    paddingLeft: '0.5em',
};
var uploadTranscriptButtonSx = {
    width: {
        xs: '100%',
        sm: '350px',
    },
    alignSelf: 'center',
};
